export default __webpack_public_path__ + "static/media/toggle.b5125c71.svg";